import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./styles/Navbar.css";
import data from "../data/imageData.json";

const toPublic = (p: string) => p.startsWith('/') ? p : p.replace(/^\.\//, '/');


const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar" aria-label="Navigare principală">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" aria-label="Sercons & Contractor — Acasă">
          <img src={toPublic(data.serconsLogo.url)} alt={data.serconsLogo.alt} width="717" height="392" />
        </Link>
        <button
          className={`hamburger ${isOpen ? "open" : ""}`}
          onClick={toggleMenu}
          aria-label={isOpen ? "Închide meniul" : "Deschide meniul"}
          aria-expanded={isOpen}
          aria-controls="main-navigation"
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
        <ul id="main-navigation" onClick={() => setIsOpen(false)} className={`navbar-list ${isOpen ? "open" : ""}`}>
          <li className="navbar-item">
            <Link to="/" className="navbar-link">
              Acasă
            </Link>
          </li>
          <li className="navbar-item">
            <Link to="/portfolio" className="navbar-link">
              Portofoliu
            </Link>
          </li>
          <li className="navbar-item">
            <Link to="/desprenoi" className="navbar-link">
              Despre Noi
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
